import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Distributor } from '../../shared/models/Distributor';
import { FilterObject } from '../../shared/models/FilterObject';
import { PagingResults } from '../../shared/models/PagingResult';
import { RMA } from '../../shared/models/RMA';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { faShare,faEye } from '@fortawesome/free-solid-svg-icons';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { RMAResponse } from '../../shared/models/RMAResponse';
import { HttpResponse } from '@angular/common/http';
import { RMAItem } from '../../shared/models/RMAItem';
import { MatMenu } from '@angular/material/menu';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-rma',
  templateUrl: './rma.component.html',
  styleUrls: ['./rma.component.css']
})
export class RmaComponent implements OnInit, OnDestroy {
  @ViewChild(MatMenu) matFilterMenu: MatMenu;
  readonly Page: string = "RMA";
  RMAList: RMA[];
  DistList: Distributor[];
  CurrentDist: string;
  DistSubscription: Subscription;
  CurUser: User;
  RMASortValue: string;
  FilterList: FilterObject[];
  CustFilter: FilterObject;
  RMANumber_Filter: FilterObject;
  RepairOrder_Filter: FilterObject;
  OriginalOrder_Filter: FilterObject;
  RMADateMin_Filter: FilterObject;
  RMADateMax_Filter: FilterObject;
  PONumber_Filter: FilterObject;
  ShipTo_Filter: FilterObject;
  Max_EndDate: Date;
  PageIndex: number;
  PageSize: number;
  ItemCount: number;
  faShare = faShare;
  faEye = faEye;
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  readonly PageSizeOptions: number[] = [5, 10, 20, 50];
  hideLoadingModal: boolean;
  constructor(private global: GlobalService, private http: HttpService, private router: Router,public matDialog: MatDialog) {

    //look for state object to pre select distributor and filter(sort)
    var curNavigation = this.router.getCurrentNavigation();
    if (curNavigation) {
      var stateObject = curNavigation.extras.state;
      if (stateObject) {
        if (stateObject.sortValue) {
          this.RMASortValue = stateObject.sortValue;
        }

        if (stateObject.distributor) {
          this.CurrentDist = stateObject.distributor;
        }
      }

    }

  }

  ngOnInit(): void {
    this.CurUser = new User();
    this.hideLoadingModal = true;
    this.PageIndex = 0;
    this.PageSize = 20;
    this.Max_EndDate = new Date();
    var isInitialLoad = true;
    this.RMASortValue = this.RMASortValue ?? "received";
    
    this.RMAList = [];
    this.FilterList = [];
    this.CustFilter = new FilterObject();
    this.RMANumber_Filter = new FilterObject();
    this.RMANumber_Filter.Key = "rmanumber";
    this.FilterList.push(this.RMANumber_Filter);
    this.RepairOrder_Filter = new FilterObject();
    this.RepairOrder_Filter.Key = "repairorder";
    this.FilterList.push(this.RepairOrder_Filter);
    this.OriginalOrder_Filter = new FilterObject();
    this.OriginalOrder_Filter.Key = "ordernumber";
    this.FilterList.push(this.OriginalOrder_Filter);
    this.RMADateMax_Filter = new FilterObject();
    this.RMADateMax_Filter.Key = "orderdate";
    this.RMADateMax_Filter.Operand = "lt";
    this.RMADateMax_Filter.Value = this.Max_EndDate.toISOString();
    this.FilterList.push(this.RMADateMax_Filter);
    this.RMADateMin_Filter = new FilterObject();
    this.RMADateMin_Filter.Key = "orderdate";
    this.RMADateMin_Filter.Operand = "gt";
    this.FilterList.push(this.RMADateMin_Filter);
    this.PONumber_Filter = new FilterObject();
    this.PONumber_Filter.Key = "ponumber";
    this.FilterList.push(this.PONumber_Filter);
    this.ShipTo_Filter = new FilterObject();
    this.ShipTo_Filter.Key = "shipto";
    this.FilterList.push(this.ShipTo_Filter);
    this.CustFilter.Key = "customer";

    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
      if (!this.CurUser || this.CurUser == null) {
        this.router.navigate(['/']);
      }
      this.http.PostUserActivity(this.CurUser.UserId.toString(), "RMA", "Load", "");
      var dist = this.global.getCurrentDist();

      if (this.CurUser && (this.CurUser.Distributor != null || this.CurUser.IsTolomaticUser)) {
        this.http.GetDistributors().then(x => {
          if (x.StatusCode == "200") {
            this.DistList = x.Content;
            var index = 1;
            this.DistList.forEach(dist => {
              dist.SortIndex = index;
              index++;
            });


            var allDist = new Distributor();
            allDist.Company = "All Distributors";
            allDist.CompanyId = "00000000-0000-0000-0000-000000000000";
            allDist.SortIndex = 0;
            this.DistList.push(allDist);
            this.DistList.sort((a, b) => {
              if (a.SortIndex > b.SortIndex) {
                return 1;
              }
              else {
                return -1;
              }
            });
            if (dist) {
              if (!this.CurUser.IsTolomaticUser && this.CurUser.DistributorId == dist.CompanyId) {
                this.CurrentDist = dist.CompanyId;
              }
              else if (this.CurUser.IsTolomaticUser) {
                this.CurrentDist = dist.CompanyId;
              }
              else {
                this.CurrentDist = this.CurUser.DistributorId;
              }
            }
            else {
              if (!this.CurUser.IsTolomaticUser && this.CurUser.DistributorId != "") {
                this.CurrentDist = this.CurUser.DistributorId;
              } else {
                this.CurrentDist = this.DistList[0].CompanyId;
              }
            }


            this.CustFilter.Operand = "equals";
            this.CustFilter.Value = this.CurrentDist;

            this.FilterList.push(this.CustFilter);

          }

          this.GetRMAs();

        });
        this.DistSubscription = this.global.CurrentDist.subscribe(dist => {
          debugger;
          if (dist && dist.CompanyId != this.CurrentDist && !isInitialLoad) {
            this.CurrentDist = dist.CompanyId;
            this.CustFilter.Value = this.CurrentDist;
            this.GetRMAs();
          }
          isInitialLoad = false;
        });
      }
      else {
        this.router.navigate(['/']);
      }
    });
  }

  ngOnDestroy() {
    if (this.DistSubscription) {
      this.DistSubscription.unsubscribe();
    }
  }

  GetRMAs() {
    this.hideLoadingModal = false;
    this.http.GetRMA(this.FilterList, this.CurUser.UserId.toString(), this.PageIndex, this.PageSize,this.RMASortValue).then(wrap => {
      if (wrap.StatusCode == "200") {
        var result = <PagingResults>wrap.Content;
        this.RMAList = result.Items;
        this.ItemCount = result.ItemCount;
        this.RMAList.forEach(rma => {
          rma.ShortShipTo = rma.ShipToName;
          
          if (rma.ShortShipTo.length > 25) {
            rma.ShortShipTo = rma.ShortShipTo.substring(0, 25) + "...";
          }
          //rma.RMAItems.forEach(item => {
          //  item.ShortReason = item.Reason.length > 35 ? item.Reason.substring(0, 35) + "..." : item.Reason;
          //  item.ShortDesc = item.Description.length > 35 ? item.Description.substring(0, 35) + "..." : item.Description;
          //});
          
        });
        this.ItemCount = result.ItemCount;
      }
      this.hideLoadingModal = true;
    });
  }

  LoadDetails(rma: RMA) {
    if (!rma.RMAItems) {
      this.hideLoadingModal = false;
      this.http.GetRMAItems(rma.RMANumber, this.CurUser.UserId.toString()).then(x => {
        if (x.StatusCode == "200") {
          rma.RMAItems = x.Content;
          rma.RMAItems.forEach(item => {
            item.ShortReason = item.Reason.length > 35 ? item.Reason.substring(0, 35) + "..." : item.Reason;
            item.ShortDesc = item.Description.length > 35 ? item.Description.substring(0, 35) + "..." : item.Description;
          });
        }
        this.hideLoadingModal = true;
      });
    }
  }


  Dist_Change(event: any) {
    //this.CurrentDist = event.value;
    //this.CustFilter.Value = this.CurrentDist;
    if (event.value != "00000000-0000-0000-0000-000000000000") {
      var newDist = this.DistList.filter(x => x.CompanyId == event.value)[0];
      this.global.setCurrentDist(newDist);
    }
    else {
      this.CurrentDist = event.value;
      this.CustFilter.Value = this.CurrentDist;
      this.GetRMAs();
    }
    
  }

  RMASort_Change(event: any) {
    this.RMASortValue = event.value;
    this.GetRMAs();
  }

  RespondToRMA(rma: RMA, rmaItem:RMAItem) {
    var dialogConfig = this.GetDialogConfig("RMARespond");

    var rmaObject = {
      type: "RMAResponse", object: { rma: rma, rmaItem: rmaItem }
    };
    dialogConfig.data = rmaObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {

      var response = <RMAResponse>event;

      this.SubmitResponse(response).then(success => {
        if (success) {
          this.http.PostUserActivity(this.CurUser.UserId.toString(), "RMA", "RMA Respond",response.RMANumber);
          this.CurrentOpenDialog.close();
        }
      });

    });

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CurrentOpenDialog.close();
    });
  }

  RespondToRMAItem(rma:RMA,item: RMAItem) {
    var dialogConfig = this.GetDialogConfig("RMARespond");

    var rmaObject = {
      type: "RMAResponse", object: { rma: rma, rmaItem: item }};
    dialogConfig.data = rmaObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {

      var response = <RMAResponse>event;

      this.SubmitResponse(response).then(success => {
        if (success) {
          this.http.PostUserActivity(this.CurUser.UserId.toString(), "RMA", "RMA Respond",response.RMANumber);
          this.CurrentOpenDialog.close();
        }
      });

    });

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CurrentOpenDialog.close();
    });
  }

  async SubmitResponse(response: RMAResponse): Promise<boolean> {
    if (response.Action != "" && response.RMANumber != null) {


      return await this.http.SubmitRMAResponse(response, this.CurUser.UserId.toString()).then(x => {
        if (x.StatusCode == "200") {
          return true;
        }
        else {
          return false;
        }
      });
    }
  }

  SubmitFilters() {
    //this.matFilterMenu.close.emit();
    this.GetRMAs();

  }

  SetStartDateFilterValue(event: any) {
    this.RMADateMin_Filter.Value = event.value;
  }

  SetEndDateFilterValue(event: any) {
    this.RMADateMax_Filter.Value = event.value;
  }

  DownloadVerification(rma:RMA) {
    if (rma.RMAVerificationPath.length > 0) {
      this.http.PostUserActivity(this.CurUser.UserId.toString(), "RMA", "Download RMA Verification", rma.RMANumber);
      var rmaVeriName = rma.RMAVerificationPath;
      
      this.http.DownloadRMAVerification(rmaVeriName).subscribe(({ body, headers }: HttpResponse<any>) => {
        debugger;
        var contentType = headers.get('content-type');
        const blob = new Blob([body], { type: contentType });
        var fileURL = URL.createObjectURL(blob);

        var a = document.createElement("a");
        a.href = fileURL;
        a.download = rma.RMANumber + ".pdf";
        a.click();

      });
    }
  }

  ViewRMAVerification(rma: RMA) {

    if (rma.RMAVerificationPath.length > 0) {

      this.http.PostUserActivity(this.CurUser.UserId.toString(), "RMA Detail Summary", "Download RMA Verification", rma.RMANumber);
      var rmaVeriName = rma.RMANumber;
      
      rmaVeriName += "-1";
      rmaVeriName += ".pdf";
      this.http.DownloadRMAVerification(rmaVeriName).subscribe(({ body, headers }: HttpResponse<any>) => {
        debugger;
        var contentType = headers.get('content-type');
        const blob = new Blob([body], { type: contentType });
        var fileURL = URL.createObjectURL(blob);

        var a = document.createElement("a");
        a.href = fileURL;
        a.download = rma.RMANumber + ".pdf";
        a.click();

      });
    }
  }

  PageEvent(event: any) {
    this.PageIndex = event.pageIndex;
    this.PageSize = event.pageSize;
    this.GetRMAs();
  }

  FollowOrder(checked: boolean, rmaItemRowPointer: string) {
    this.http.PostUserActivity(this.CurUser.UserId.toString(), "RMA", "Follow RMA", rmaItemRowPointer);
    this.http.FollowRMA(checked, rmaItemRowPointer, this.CurUser.UserId.toString());
  }


  ResetFilters() {
    this.RMADateMax_Filter.Value = this.Max_EndDate.toISOString();
    this.RMADateMin_Filter.Value = "";
    this.RepairOrder_Filter.Value = "";
    this.RMANumber_Filter.Value = "";
    this.OriginalOrder_Filter.Value = "";
    this.PONumber_Filter.Value = "";
    this.ShipTo_Filter.Value = "";
    this.matFilterMenu.close.emit();
    this.GetRMAs();
  }

  //OpenRMA(rma: RMA) {
  //  var dialogConfig = this.GetDialogConfig("RMAItem");

  //  var rmaObject = { type: "RMA", object: rma };
  //  dialogConfig.data = rmaObject;

  //  this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

  //  this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
  //    this.CurrentOpenDialog.close();
  //  });
  //}

  OpenRMAItem(rma: RMA,rmaItem:RMAItem) {
    var dialogConfig = this.GetDialogConfig("RMAItem");

    var rmaObject = {
      type: "RMA", object: { rma: rma, rmaItem: rmaItem } };
    dialogConfig.data = rmaObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);
    
    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CurrentOpenDialog.close();
    });
  }

  GetDialogConfig(name: string): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = name;
    dialogConfig.height = "80%";
    dialogConfig.width = "70%";

    return dialogConfig;
  }

  GetRMAItemStatusText(item: RMAItem): string {
    if (item.RMAStatus == "F" && item.RepairOrder.indexOf("SV") < 0 && item.Disp.length > 0) {
      return "In Order Entry";
    }
    else if (item.RMAStatus == "F" && item.RepairOrder.indexOf("SV") < 0) {
      return "Response Needed";
    }
    else if (item.RMAStatus == "F" && item.RepairOrder.indexOf("SV") >= 0) {
      return "In Process";
    }
    else {
      return item.RMAStatus;
    }


  }

}
